// import React, { useEffect, useState } from "react";
// import Navbar from "../components/navbar";

// const API_BASE = process.env.REACT_APP_API_BASE;

// const Admin = () => {
//   const [accounts, setAccounts] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [roleFilter, setRoleFilter] = useState("");
//   const [verifyFilter, setVerifyFilter] = useState("");

//   useEffect(() => {
//     const fetchAccounts = async () => {
//       try {
//         const res = await fetch(`${API_BASE}/admin/accounts`);
//         const data = await res.json();
//         setAccounts(data);
//         setFiltered(data);
//       } catch (err) {
//         console.error("Failed to fetch accounts:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchAccounts();
//   }, []);

//   const handleVerify = async (id) => {
//     try {
//       await fetch(`${API_BASE}/admin/accounts/${id}/verify`, { method: "PUT" });
//       alert(`User ${id} verified successfully`);
//       setAccounts((prev) =>
//         prev.map((u) => (u.id === id ? { ...u, is_verified: true } : u))
//       );
//     } catch {
//       alert("Failed to verify user");
//     }
//   };

//   const handleDelete = async (id) => {
//     try {
//       await fetch(`${API_BASE}/admin/accounts/${id}`, { method: "DELETE" });
//       alert(`User ${id} deleted successfully`);
//       setAccounts((prev) => prev.filter((u) => u.id !== id));
//     } catch {
//       alert("Failed to delete user");
//     }
//   };

//   useEffect(() => {
//     let data = [...accounts];
//     if (search.trim()) {
//       data = data.filter(
//         (u) =>
//           u.email.toLowerCase().includes(search.toLowerCase()) ||
//           u.id.toString().includes(search)
//       );
//     }
//     if (roleFilter) data = data.filter((u) => u.role === roleFilter);
//     if (verifyFilter)
//       data = data.filter((u) =>
//         verifyFilter === "verified" ? u.is_verified : !u.is_verified
//       );
//     setFiltered(data);
//   }, [search, roleFilter, verifyFilter, accounts]);

//   if (loading) return <div className="text-center p-8">Loading accounts...</div>;

//   return (
//     <div className="min-h-screen bg-gray-100 p-8">
//       <Navbar />
//       <section className="max-w-6xl mx-auto text-center mt-24 mb-8">
//         <h1 className="text-5xl font-bold text-gray-900">
//           <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-cyan-500">
//             User Accounts
//           </span>
//         </h1>
//       </section>

//       <div className="flex flex-wrap gap-4 justify-center mb-6 sticky top-0 bg-gray-100 py-4 z-10">
//         <input
//           type="text"
//           placeholder="Search by ID or Email"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           className="border border-gray-300 rounded-lg p-2 w-64"
//         />
//         <select
//           value={roleFilter}
//           onChange={(e) => setRoleFilter(e.target.value)}
//           className="border border-gray-300 rounded-lg p-2"
//         >
//           <option value="">All Roles</option>
//           <option value="admin">Admin</option>
//           <option value="visitor">Visitor</option>
//         </select>
//         <select
//           value={verifyFilter}
//           onChange={(e) => setVerifyFilter(e.target.value)}
//           className="border border-gray-300 rounded-lg p-2"
//         >
//           <option value="">All</option>
//           <option value="verified">Verified</option>
//           <option value="unverified">Unverified</option>
//         </select>
//       </div>

//       <div className="bg-white shadow-md rounded-lg overflow-x-auto">
//         <table className="min-w-full text-left">
//           <thead className="bg-gray-50 sticky top-0">
//             <tr>
//               <th className="px-6 py-3">ID</th>
//               <th className="px-6 py-3">Email</th>
//               <th className="px-6 py-3">Role</th>
//               <th className="px-6 py-3">Verified</th>
//               <th className="px-6 py-3">Created At</th>
//               <th className="px-6 py-3">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filtered.map((acc) => (
//               <tr key={acc.id} className="border-t hover:bg-gray-50">
//                 <td className="px-6 py-4">{acc.id}</td>
//                 <td className="px-6 py-4">{acc.email}</td>
//                 <td className="px-6 py-4">{acc.role}</td>
//                 <td className="px-6 py-4">{acc.is_verified ? "✅" : "❌"}</td>
//                 <td className="px-6 py-4">
//                   {new Date(acc.created_at).toLocaleString()}
//                 </td>
//                 <td className="px-6 py-4 space-x-3">
//                   {!acc.is_verified && (
//                     <button
//                       onClick={() => handleVerify(acc.id)}
//                       className="px-3 py-1 border border-green-500 text-green-600 rounded-md hover:bg-green-50"
//                     >
//                       Verify
//                     </button>
//                   )}
//                   <button
//                     onClick={() => handleDelete(acc.id)}
//                     className="px-3 py-1 border border-red-500 text-red-600 rounded-md hover:bg-red-50"
//                   >
//                     Delete
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default Admin;











import React, { useEffect, useState } from "react";
import Navbar from "../components/navbar";

const API_BASE = process.env.REACT_APP_API_BASE;

const Admin = () => {
  const [accounts, setAccounts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [verifyFilter, setVerifyFilter] = useState("");

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const res = await fetch(`${API_BASE}/admin/accounts`);
        const data = await res.json();
        setAccounts(data);
        setFiltered(data);
      } catch (err) {
        console.error("Failed to fetch accounts:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchAccounts();
  }, []);

  const handleVerify = async (id) => {
    try {
      await fetch(`${API_BASE}/admin/accounts/${id}/verify`, { method: "PUT" });
      alert(`User ${id} verified successfully`);
      setAccounts((prev) =>
        prev.map((u) => (u.id === id ? { ...u, is_verified: true } : u))
      );
    } catch {
      alert("Failed to verify user");
    }
  };

  const handleDelete = async (id) => {
    try {
      await fetch(`${API_BASE}/admin/accounts/${id}`, { method: "DELETE" });
      alert(`User ${id} deleted successfully`);
      setAccounts((prev) => prev.filter((u) => u.id !== id));
    } catch {
      alert("Failed to delete user");
    }
  };

  // 🆕 Update user permission/role
  const handleRoleChange = async (id, newRole) => {
    if (!newRole.trim()) return;
    if (!window.confirm(`Change this user's permission to "${newRole}"?`))
      return;

    try {
      const res = await fetch(`${API_BASE}/admin/accounts/${id}/role`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ role: newRole }),
      });
      if (!res.ok) throw new Error("Failed to update permission");
      alert("Permission updated successfully");
      setAccounts((prev) =>
        prev.map((u) => (u.id === id ? { ...u, role: newRole } : u))
      );
    } catch {
      alert("Failed to update permission");
    }
  };

  useEffect(() => {
    let data = [...accounts];
    if (search.trim()) {
      data = data.filter(
        (u) =>
          u.email.toLowerCase().includes(search.toLowerCase()) ||
          u.id.toString().includes(search)
      );
    }
    if (roleFilter) data = data.filter((u) => u.role === roleFilter);
    if (verifyFilter)
      data = data.filter((u) =>
        verifyFilter === "verified" ? u.is_verified : !u.is_verified
      );
    setFiltered(data);
  }, [search, roleFilter, verifyFilter, accounts]);

  if (loading) return <div className="text-center p-8">Loading accounts...</div>;

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <Navbar />
      <section className="max-w-6xl mx-auto text-center mt-24 mb-8">
        <h1 className="text-5xl font-bold text-gray-900">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-cyan-500">
            User Accounts
          </span>
        </h1>
      </section>

      <div className="flex flex-wrap gap-4 justify-center mb-6 sticky top-0 bg-gray-100 py-4 z-10">
        <input
          type="text"
          placeholder="Search by ID or Email"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border border-gray-300 rounded-lg p-2 w-64"
        />
        <select
          value={roleFilter}
          onChange={(e) => setRoleFilter(e.target.value)}
          className="border border-gray-300 rounded-lg p-2"
        >
          <option value="">All Roles</option>
          <option value="admin">Admin</option>
          <option value="visitor">Visitor</option>
        </select>
        <select
          value={verifyFilter}
          onChange={(e) => setVerifyFilter(e.target.value)}
          className="border border-gray-300 rounded-lg p-2"
        >
          <option value="">All</option>
          <option value="verified">Verified</option>
          <option value="unverified">Unverified</option>
        </select>
      </div>

      <div className="bg-white shadow-md rounded-lg overflow-x-auto">
        <table className="min-w-full text-left">
          <thead className="bg-gray-50 sticky top-0">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Email</th>
              <th className="px-6 py-3">Permission</th>
              <th className="px-6 py-3">Verified</th>
              <th className="px-6 py-3">Created At</th>
              <th className="px-6 py-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((acc) => (
              <tr key={acc.id} className="border-t hover:bg-gray-50">
                <td className="px-6 py-4">{acc.id}</td>
                <td className="px-6 py-4">{acc.email}</td>
                {/* 🆕 Editable textbox for permission */}
                <td className="px-6 py-4">
                  <input
                    type="text"
                    defaultValue={acc.role}
                    onBlur={(e) => handleRoleChange(acc.id, e.target.value)}
                    className="border border-gray-300 rounded-md px-2 py-1 w-28"
                  />
                </td>
                <td className="px-6 py-4">{acc.is_verified ? "✅" : "❌"}</td>
                <td className="px-6 py-4">
                  {new Date(acc.created_at).toLocaleString()}
                </td>
                <td className="px-6 py-4 space-x-3">
                  {!acc.is_verified && (
                    <button
                      onClick={() => handleVerify(acc.id)}
                      className="px-3 py-1 border border-green-500 text-green-600 rounded-md hover:bg-green-50"
                    >
                      Verify
                    </button>
                  )}
                  <button
                    onClick={() => handleDelete(acc.id)}
                    className="px-3 py-1 border border-red-500 text-red-600 rounded-md hover:bg-red-50"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Admin;
